var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useGameContext } from "../GameContext";
import Button from "../../ui/Button/Button";
import Label from "../../ui/Label/Label";
import Input from "../../ui/Input/Input";
import Divider from "../../ui/Divider/Divider";
import RollOverIcon from "../../assets/rollOver";
import { LabelType } from "../../ui/Label";
export var SeedSettings = function (_a) {
    var useNew = _a.useNew, getGameData = _a.getGameData, getNonceData = _a.getNonceData, session_id = _a.session_id;
    var _b = useGameContext(), clientSeed = _b.clientSeed, setClientSeed = _b.setClientSeed, customClientSeed = _b.customClientSeed, setCustomClientSeed = _b.setCustomClientSeed;
    var _c = useState(clientSeed), customSeedInput = _c[0], setCustomSeedInput = _c[1];
    var _d = useState(customClientSeed), custom = _d[0], setCustom = _d[1];
    var _e = useState(false), isError = _e[0], setIsError = _e[1];
    var _f = useState(null), gameData = _f[0], setGameData = _f[1];
    var _g = useState(null), nonceData = _g[0], setNonceData = _g[1];
    useEffect(function () {
        var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getGameData({ session_id: session_id }).then(function (result) {
                            setGameData(result);
                        })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, getNonceData({ session_id: session_id }).then(function (result) {
                                setNonceData(result);
                            })];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        fetchData();
    }, []);
    var generateNextClientSeed = function () {
        var arr = new Uint8Array(48);
        window.crypto.getRandomValues(arr);
        var seed = Array.from(arr, function (x) { return x.toString(16).padStart(2, "0"); }).join("");
        setCustomSeedInput(seed);
        setCustom(false);
        return seed;
    };
    var useNewSeeds = function () {
        if (isError)
            return;
        setClientSeed(customSeedInput);
        setCustomClientSeed(custom);
        useNew();
    };
    var updateLocalInput = function (value) {
        if (value.length < 1 || value.length > 128) {
            setIsError(true);
        }
        else {
            setIsError(false);
        }
        setCustomSeedInput(value);
        setCustom(true);
    };
    return (_jsxs(_Fragment, { children: [_jsx(Label, { type: LabelType.Title, children: "Current seeds" }), _jsx(Label, { children: "Server Seed" }), _jsx(Input, { variant: "default", type: "text", value: (gameData === null || gameData === void 0 ? void 0 : gameData[0].server_secret_hash) || "", readOnly: true }), _jsx(Label, { children: "Client Seed" }), _jsx(Input, { variant: "default", type: "text", value: clientSeed, readOnly: true }), _jsx(Label, { children: "Nonce" }), _jsx(Input, { variant: "default", type: "text", value: (nonceData === null || nonceData === void 0 ? void 0 : nonceData.nonce.toString()) || "", readOnly: true }), _jsx(Divider, {}), _jsx(Label, { type: LabelType.Title, children: "New seeds" }), _jsx(Label, { children: "Server Seed (hash)" }), _jsx(Input, { variant: "default", type: "text", value: (nonceData === null || nonceData === void 0 ? void 0 : nonceData.hash) || "", readOnly: true }), _jsx(Label, { children: "Client Seed" }), isError ? (_jsx(Label, { type: LabelType.Error, children: "Client Seed must be between 1 and 128 characters long." })) : null, _jsx(Input, { variant: "default", type: "text", value: customSeedInput, onChange: function (e) { return updateLocalInput(e.currentTarget.value); }, rightContent: _jsx(Button, { variant: "inputButton", onClick: generateNextClientSeed, children: _jsx(RollOverIcon, {}) }) }), _jsx(Label, { children: "Nonce" }), _jsx(Input, { variant: "default", type: "text", value: ((nonceData === null || nonceData === void 0 ? void 0 : nonceData.nonce) + 1).toString() || "", readOnly: true }), _jsx(Button, { disabled: isError, variant: "action", onClick: useNewSeeds, children: "Use New Seeds" })] }));
};
//# sourceMappingURL=SeedSettings.js.map